import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { TableHead } from '@/components/ui/table';
import type { SortDirection, SortKey } from '@/lib/contractSort';

export function SortableTableHead({
  label,
  sortKey,
  activeSortKey,
  direction,
  onSort,
  className,
}: {
  label: string;
  sortKey: SortKey;
  activeSortKey: SortKey | null;
  direction: SortDirection;
  onSort: (key: SortKey) => void;
  className?: string;
}) {
  const isActive = activeSortKey === sortKey;

  return (
    <TableHead className={className}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className="inline-flex items-center gap-1"
      >
        {label}
        {isActive ? (
          direction === 'asc' ? (
            <ArrowDown className="h-4 w-4 intl-text-primary" />
          ) : (
            <ArrowUp className="h-4 w-4 intl-text-primary" />
          )
        ) : (
          <ArrowUpDown className="h-4 w-4 intl-text-label" />
        )}
      </button>
    </TableHead>
  );
}
